import { render, staticRenderFns } from "./OCardUserComp.vue?vue&type=template&id=6fa3e2d9&"
import script from "./OCardUserComp.vue?vue&type=script&lang=js&"
export * from "./OCardUserComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports